<script>
    import { apiMethods } from "../../Services/index.svelte";
    import { AustralianStates } from "../../Utils/utilEnums.svelte";
    import {
        getEmailValidation,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";

    export let type = "",
        editObj = {},
        isModalOpen = false,
        afterModifyFunc = () => {},
        closeModifyModal = () => {};

    $: isNewObj = !editObj.hasOwnProperty("id");

    $: isValidObjEmail = editObj.email
        ? getEmailValidation(editObj.email)
        : true;

    $: isSubmitBtnDisabled = !isValidObjEmail || isUpdating;

    $: isObjFromWorkCover = type && type.toLowerCase() == "workcover";

    $: isObjFromTraffic = type && type.toLowerCase() == "traffic";

    let isUpdating = false;

    const updateAuthority = async () => {
        isUpdating = true;

        if (isObjFromWorkCover) await updateWorkcover();
        else if (isObjFromTraffic) await updateTraffic();

        isUpdating = false;

        afterModifyFunc();
    };

    const updateWorkcover = async () => {
        if (isNewObj)
            await apiMethods.postMethod
                .createWorkcoverAuthority(editObj)
                .then((res) => {
                    if (!res || res.error) showError(res.error);
                })
                .catch((err) => showException(err));
        else
            await apiMethods.putMethod
                .updateWorkcoverAuthority(editObj)
                .then((res) => {
                    if (!res || res.error) showError(res.error);
                })
                .catch((err) => showException(err));
    };

    const updateTraffic = async () => {
        if (editObj.hasOwnProperty("amaRates")) delete editObj.amaRates;

        if (isNewObj)
            await apiMethods.postMethod
                .createTrafficAccidentAuthority(editObj)
                .then((res) => {
                    if (!res || res.error) showError(res.error);
                })
                .catch((err) => showException(err));
        else
            await apiMethods.putMethod
                .updateTrafficAccidentAuthority(editObj)
                .then((res) => {
                    if (!res || res.error) showError(res.error);
                })
                .catch((err) => showException(err));
    };
</script>

<div class={isModalOpen ? "modal modal-open sm:modal-middle" : "modal"}>
    <div class="modal-box no-transform h-auto max-h-[600px] p-0 flex flex-col">
        <h3
            class="font-medium text-lg text-[#fff] flex-0 bg-[#8a3ed7] px-6 py-3"
        >
            {isNewObj ? "Create" : "Edit"}
            {type} authority
        </h3>

        <div class="flex flex-1 flex-col gap-y-4 relative overflow-y-auto p-6">
            <div class="flex gap-x-4">
                <p class="w-36">State:</p>
                <select
                    class="input input-sm input-bordered w-full"
                    bind:value={editObj.state}
                >
                    {#each AustralianStates as state}
                        <option value={state.key}>
                            {state.key.toUpperCase()}
                        </option>
                    {/each}
                </select>
            </div>

            <div class="flex gap-x-4">
                <p class="w-36">Name:</p>
                <input
                    type="text"
                    class="input input-sm input-bordered w-full"
                    autocomplete="off"
                    bind:value={editObj.name}
                />
            </div>

            <div class="flex gap-x-4">
                <p class="w-36">Email:</p>
                <input
                    type="text"
                    class="input input-sm input-bordered w-full"
                    autocomplete="off"
                    bind:value={editObj.email}
                />
            </div>

            {#if !isValidObjEmail}
                <span class="label-text-alt text-error"> Invalid email </span>
            {/if}

            {#if isObjFromWorkCover}
                <div class="flex gap-x-4">
                    <p class="w-36">AMA rates:</p>
                    <div class="w-full">
                        <input
                            type="checkbox"
                            class="toggle toggle-secondary"
                            autocomplete="off"
                            bind:checked={editObj.amaRates}
                        />
                    </div>
                </div>
            {/if}

            <div class="modal-action flex items-center justify-end gap-x-4">
                <button
                    class="btn btn-error text-white btn-sm border-none w-36"
                    disabled={isUpdating}
                    on:click={closeModifyModal}>Close</button
                >

                <button
                    class={`btn btn-secondary text-white btn-sm border-none ${
                        isUpdating ? "loading w-48" : "w-36"
                    }`}
                    disabled={isSubmitBtnDisabled}
                    on:click={updateAuthority}
                >
                    {isUpdating
                        ? isNewObj
                            ? "Creating"
                            : "Updating"
                        : isNewObj
                          ? "Create"
                          : "Update"}
                </button>
            </div>
        </div>
    </div>
</div>
